<section class="content">
  <div class="card" style="padding:25px">

  <div class="container">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" [min]="from_date" />
      </div>
      <div class="col-1"></div>
      <div class="col">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 4%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="to_date == null || from_date == null">Get</button>
      </div>
    </div>
    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let enquiry_log of enquiry_log_data['enquiry_log']"
        style="border-radius: 8px; margin-bottom: 1%;">
        <mat-expansion-panel-header style="padding: 30px;" [style.background]="enquiry_log.success_count > 0 ? '#00e296': 'white'">
          <mat-panel-title>
            <b>{{ enquiry_log['run_time'] | date }} - {{ enquiry_log['run_time'] | date: 'h:mm a' }}</b> &nbsp; &nbsp; <span
              style="font-style: italic;">{{ enquiry_log['run_type'] }}:</span>&nbsp; &nbsp;
            <label>Transaction Window {{ enquiry_log['start_time'] | date: 'h:mm a'}} -
              {{ enquiry_log['end_time'] | date: 'h:mm a'}}.</label>&nbsp;&nbsp;
            <label>{{ enquiry_log['success_count'] }} / {{ enquiry_log ['candidate_count']}} turned Successfull.</label>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="enquiry_log_data['enquiry_property'].hasOwnProperty(enquiry_log['id'])">
          <table class="table table-bordered table-hover">
            <thead style="background: bisque;">
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Booth / Customer Code</th>
                <th>Payment Initiated Time</th>
                <th>Amount Return to Wallet</th>
                <th>Morning Order Placed</th>
                <th>Morning Order Amount</th>
                <th>Evening Order Placed</th>
                <th>Evening Order Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let property_log of enquiry_log_data['enquiry_property'][enquiry_log['id']];  let property_log_index=index ">
                <td>{{ property_log_index + 1 }}</td>
                <td>{{ property_log['first_name']}}</td>
                <td>{{ property_log['booth_code']}}</td>
                <td>{{ property_log['payment_requested_time'] | date: 'short'}}</td>
                <td>{{ property_log['amount_sent_to_wallet'] | currency: 'INR'}}</td>
                <td>{{ property_log['is_mor_order_placed']}}</td>
                <td>{{ property_log['morning_order_amount'] | currency: 'INR'}}</td>
                <td>{{ property_log['is_eve_order_placed']}}</td>
                <td>{{ property_log['evening_order_amount'] | currency: 'INR'}}</td>
              </tr>
            </tbody>
          </table>

        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  </div>
</section>
